import { useNavigation } from '@react-navigation/native';
import { Button, Meta, SpeechBubble, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { Wrapper } from 'components/park/ParkingZoneDetails';
import useDynamicSheetSize from 'hooks/useDynamicSheetSize';
import { useParkingButtonLogic } from 'hooks/useParkingButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParkingStore } from 'stores/parkingStore';
import { useParkzoneStore } from 'stores/parkzoneStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { ParkNavProps } from 'types/navigation';
import { testIdentifiers } from 'utils/testIdentifiers';

const ChargeIconComponent = () => (
  <Icon name="Charging" color={theme.colors.white} />
);

const ParkAndChargeIconComponent = () => (
  <Icon name="Park-And-Charge" color={theme.colors.white} />
);

const ChargingOptions = () => {
  const { t } = useTranslation();
  const { popTo: navigatePark } = useNavigation<ParkNavProps>();
  const { selectedParkingZoneId } = useParkingStore(
    (state) => state.parkingConditions
  );
  const { handleLayout } = useDynamicSheetSize();
  const { disabled } = useParkingButtonLogic();

  const handleCharge = () => {
    useParkzoneStore.getState().setSelectedParkingZoneTab('CHARGE');
    navigatePark('chargeSelect', { parkingZoneUid: selectedParkingZoneId });
  };

  const handleParkAndCharge = () => {
    useParkzoneStore.getState().setSelectedParkingZoneTab('PARK_AND_CHARGE');
    navigatePark('chargeSelect', { parkingZoneUid: selectedParkingZoneId });
  };

  return (
    <Wrapper onLayout={(e) => handleLayout(e.nativeEvent.layout)}>
      <StyledWrapper mb={12}>
        <SpeechBubble
          color={theme.colors.aimoUI.blue20}
          centerItem={<Meta>{t('parkAndCharge.optionsNote')}</Meta>}
          leftItem={<Icon name="Lamp" size="xl" />}
          pointerPosition="bottom"
        />
      </StyledWrapper>
      <StyledWrapper mb={20}>
        <Button
          buttonType="quaternary"
          size="l"
          text={t('button.chargeOnly')}
          iconComponent={ChargeIconComponent}
          {...testIdentifiers('park-zone-actions-charge-only-button')}
          onPress={handleCharge}
        />
      </StyledWrapper>
      <StyledWrapper>
        <Button
          buttonType="primary"
          size="l"
          text={t('button.parkAndCharge')}
          iconComponent={ParkAndChargeIconComponent}
          disabled={disabled}
          {...testIdentifiers('park-zone-actions-park-and-charge-button')}
          onPress={handleParkAndCharge}
        />
      </StyledWrapper>
    </Wrapper>
  );
};
export default ChargingOptions;
